import React from 'react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import SimpleAccessManagement from './SimpleAccessManagement';
import ToastContainer from '../ToastContainer';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
    const { adminCredentials, logoutAdmin } = useAdminAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logoutAdmin();
        navigate('/admin/login');
    };

    const handleBackToCatalog = () => {
        navigate('/');
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '20px'
        }}>
            {/* Back button */}
            <div style={{ marginBottom: '20px' }}>
                <button
                    onClick={handleBackToCatalog}
                    style={{
                        background: '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}
                >
                    ← Back to Catalog
                </button>
            </div>
            
            {/* Header */}
            <div className="admin-header">
                <div className="admin-header-title">
                    <h1>🏢 Admin Dashboard</h1>
                    <p>Manage customer portal access and quotation requests</p>
                </div>
                
                <div className="admin-header-user">
                    <div className="admin-user-info">
                        <div className="admin-user-name">
                            Welcome, {adminCredentials?.username}
                        </div>
                        <div className="admin-user-role">
                            Administrator
                        </div>
                    </div>
                    
                    <button
                        onClick={handleLogout}
                        className="admin-logout-btn"
                    >
                        🚪 Logout
                    </button>
                </div>
            </div>

            {/* Main Content */}
            <div className="admin-content-grid">
                {/* Statistics Cards */}
                <div className="admin-stats-grid">
                    <div className="admin-stat-card" style={{
                        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
                    }}>
                        <div className="admin-stat-icon">⏰</div>
                        <div className="admin-stat-title">24h Access</div>
                        <div className="admin-stat-desc">Temporary customer portal access</div>
                    </div>
                    <div className="admin-stat-card" style={{
                        background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)'
                    }}>
                        <div className="admin-stat-icon">📧</div>
                        <div className="admin-stat-title">Auto Email</div>
                        <div className="admin-stat-desc">Automatic credential delivery</div>
                    </div>
                    <div className="admin-stat-card" style={{
                        background: 'linear-gradient(135deg, #6f42c1 0%, #563d7c 100%)'
                    }}>
                        <div className="admin-stat-icon">📋</div>
                        <div className="admin-stat-title">Quote Gen</div>
                        <div className="admin-stat-desc">Direct Odoo quotation creation</div>
                    </div>
                </div>

                {/* Temporary Access Management */}
                <SimpleAccessManagement />
            </div>
            
            {/* Toast Container pour les notifications */}
            <ToastContainer />
        </div>
    );
};

export default AdminDashboard;
